module.exports = __webpack_public_path__ + "public/SiteIcons/emailVerifi.png?6c6ee516";